import {nonUserAxios} from "./NonUserAxios";
import {mediaAxios} from "./MediaAxios";
import {adminAxios} from "./AdminAxios";

export async function AxiosImage(type, uri, formData) {
  return adminAxios.request({
    url: uri,
    method: type,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function NonUserAxios(type, uri, param) {
  switch(type){
    case 'GET' : return nonUserAxios.get(uri);
    case 'POST' : return nonUserAxios.post(uri, param);
    case 'PUT' : return nonUserAxios.put(uri, param);
    case 'DELETE' : return nonUserAxios.delete(uri, {data:param});
    default : return null;
  }
}

export async function MediaAxios(type, uri, param) {
  switch(type){
    case 'GET' : return mediaAxios.get(uri);
    case 'POST' : return mediaAxios.post(uri, param);
    case 'PUT' : return mediaAxios.put(uri, param);
    case 'DELETE' : return mediaAxios.delete(uri, {data:param});
    default : return null;
  }
}

export async function AdminAxios(type, uri, param) {
  switch(type){
    case 'GET' : return adminAxios.get(uri);
    case 'POST' : return adminAxios.post(uri, param);
    case 'PUT' : return adminAxios.put(uri, param);
    case 'DELETE' : return adminAxios.delete(uri, {data:param});
    default : return null;
  }
}


export async function AxiosFile(type, uri, formData) {
  return adminAxios.request({
    url: uri,
    method: type,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

